class StickyHeader extends HTMLElement {
    constructor() {
    super();
    }

    connectedCallback() {
    this.header = document.querySelector('.shopify-section-header');
    this.header_overlay = document.querySelector('.header');
    this.headerOverlay = document.querySelector('.overlay');

    this.headerBounds = {};
    this.predictiveSearch = this.querySelector('predictive-search');
    this.currentScrollTop = 0;

    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    }

    disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
    this.headerBounds = entries[0].intersectionRect;
    observer.disconnect();
    });

    observer.observe(this.header);
    }



    onScroll() {
        let logoSlideshowFirst = document.querySelector(".first-logo-slideshow")


        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (logoSlideshowFirst) {
            let logoSlideshowFirstHeight = logoSlideshowFirst.offsetHeight
            if (scrollTop > this.currentScrollTop && scrollTop > logoSlideshowFirstHeight && scrollTop > this.headerBounds.bottom) {
                requestAnimationFrame(this.hide.bind(this));
            if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
                this.predictiveSearch.onFocusOut();
                this.predictiveSearch.onBlur();
            } 
            } else if (scrollTop - logoSlideshowFirstHeight < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                requestAnimationFrame(this.reveal.bind(this));
            } else if (scrollTop - logoSlideshowFirstHeight <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        } else {
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
        if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
            this.predictiveSearch.onFocusOut();
            this.predictiveSearch.onBlur();
        } 
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        }
    }

    hide() {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        //this.closeSearchModal();
    }

    reveal() {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.headerOverlay && this.header_overlay.classList.add('header_overlay-scroll');
        this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
        this.headerOverlay && this.header_overlay.classList.remove('header_overlay-scroll');
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
    }
}

customElements.define('sticky-header', StickyHeader);